export function countryName(code: string | null | undefined, locale: string): string {
  if (!code || !/^[A-Za-z]{2}$/.test(code)) {
    return code ?? ''
  }

  return new Intl.DisplayNames([locale], { type: 'region' }).of(code.toUpperCase()) ?? code
}
